module.exports = __webpack_public_path__ + "img/IMGP8622.9654b88b.jpg";